import { render, staticRenderFns } from "./QuestionNew.vue?vue&type=template&id=5d11ac0f&scoped=true&"
import script from "./QuestionNew.vue?vue&type=script&lang=js&"
export * from "./QuestionNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d11ac0f",
  null
  
)

export default component.exports